import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AC_SESSION_EXPIRED_ERROR, QuerstionService } from '../questionlist/table-complete/question.service';

/**
 * Landing target for the pod's "Fragen verwalten" deep link (#/watch/:scoId,
 * see qa-htmlpod's App.svelte). By the time this activates, AuthGuard has
 * already ensured the moderator is logged in (redirecting through
 * /login?scoId=... otherwise, see LoginComponent). Just claims the meeting via
 * the existing rejoinScoId/selectMeeting flow and moves on to the question
 * list - or back to the meeting picker with an error (e.g. no host/mini-host
 * permission on this meeting) if that fails.
 */
@Component({
  selector: 'app-watch-meeting',
  template: `<div class="container py-4">Verbinde mit Meeting...</div>`
})
export class WatchMeetingComponent implements OnInit {
  constructor(private route: ActivatedRoute, private service: QuerstionService, private router: Router) { }

  async ngOnInit() {
    const scoId = this.route.snapshot.paramMap.get('scoId');
    if (!scoId) {
      this.router.navigate(['meetings']);
      return;
    }
    const joined = await this.service.rejoinScoId(scoId);
    if (joined) {
      this.router.navigate(['list']);
      return;
    }
    // AuthGuard only checked the moderator's *local* login state, which can't
    // know the server just invalidated the AC session server-side (see
    // ModeratorManager.invalidateModeratorSession) - reset it here so /login
    // isn't immediately bounced back to /meetings by AuthGuard, then send the
    // moderator straight to re-login and back into this same meeting
    // afterwards (see LoginComponent), instead of stranding them on the
    // meeting picker with just an error message.
    if (this.service.lastJoinError === AC_SESSION_EXPIRED_ERROR) {
      this.service.restoreStatus = 'unauthenticated';
      this.router.navigate(['login'], { queryParams: { scoId } });
      return;
    }
    this.router.navigate(['meetings']);
  }
}

